import React, { useEffect, useLayoutEffect } from "react";
import TextContainer from "../../components/text/TextContainer";
import PageTitle from "../../components/titles/PageTitle";
import Modal from "../../components/modal/Modal";
import MainContainer from "../../components/container/MainContainer";
import { ChevronLeft, Save, Trash2 } from "lucide-react";
import { Link, useLocation, useParams } from "react-router-dom";
import Loading from "../../components/loading/Loading";
import { useDispatch, useSelector } from "react-redux";
import { useAuthorization } from "../../hooks/useAuthorization";
import { openModal } from "../../features/modalSLice";
import {
  getMethodType,
  unsetSelectedType,
} from "../../features/transactionsSlice";
import AddMethodType from "./AddMethodType";
import DeleteMethodType from "./DeleteMethodType";
import loadStatus from "../../util/loadStatus";
import NetworkError from "../error/NetworkError";

const SingleMethodType = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthorized } = useAuthorization();
  const modalContent = useSelector((state) => state.modal.content);
  const methodType = useSelector((state) => state.transactions.selectedType);
  const typeLoading = useSelector(
    (state) => state.transactions.load.getMethodType
  );

  const openEditTypeModal = (edit, id) => {
    dispatch(openModal(<AddMethodType edit={edit} id={id} />));
  };

  const openDeleteTypeModal = (id) => {
    dispatch(openModal(<DeleteMethodType id={id} />));
  };

  useLayoutEffect(() => {
    dispatch(getMethodType(id));

    return () => {
      dispatch(unsetSelectedType());
    };
  }, []);

  if (typeLoading === loadStatus.loading) {
    return <Loading />;
  }

  if (typeLoading === loadStatus.error) {
    return <NetworkError to={location.pathname} />;
  }

  return (
    <MainContainer>
      <Modal>{modalContent}</Modal>
      <PageTitle title={"Transaction Type - " + methodType.name} />
      <div className="bg-content  border border-bkg2 rounded-md p-7 mb-5 !text-text-1/55">
        <TextContainer label="Name" content={methodType.name} />
      </div>
      <div className="p-7 border border-bkg2 rounded-md flex justify-between items-center">
        <Link to="/settings/method-types" className="cancel-rss-btn">
          <ChevronLeft size={18} /> Back
        </Link>
        <div className="flex gap-3">
          <button
            onClick={(e) => openEditTypeModal(true, id)}
            disabled={!isAuthorized("settings", "update")}
            className="add-rss-btn"
          >
            <Save size={18} />
            Edit
          </button>
          <button
            onClick={(e) => openDeleteTypeModal(id)}
            disabled={!isAuthorized("settings", "delete")}
            className="delete-rss-btn"
          >
            <Trash2 size={18} />
            Delete
          </button>
        </div>
      </div>
    </MainContainer>
  );
};

export default SingleMethodType;
